var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isSubmitted)?_c('section',{staticClass:"call-back"},[(_vm.isSuccess)?_c('p',{staticClass:"call-back__success"},[_vm._v("\n    "+_vm._s(_vm.$t('contact.success'))+"\n  ")]):_c('p',{staticClass:"call-back__error"},[_vm._v("\n    "+_vm._s(_vm.$t('contact.error'))+"\n  ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }